// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feedItemHeader":"e3gVMQ8XE_HSOBVAHEimw","ideaResearchItem":"eJPObBGNUWpPXBfFJ6sfA"};